<template>
  <div v-if="sections.length">
    <v-layout row wrap pt-4>
      <v-flex xs12 md4 :class="{'pr-2': $vuetify.breakpoint.smAndUp}" v-if="section1">
        <a :href="section1.url" :target="section1.is_blank">
          <SectionsCardB :section_image="section1.image"/>
        </a>
      </v-flex>
      <v-flex xs12 md4 :class="{'pl-2 pr-2': $vuetify.breakpoint.smAndUp}" v-if="section2">
        <a :href="section2.url" :target="section2.is_blank">
          <SectionsCardB :section_image="section2.image"/>
        </a>
      </v-flex>
      <v-flex xs12 md4 :class="{'pl-2': $vuetify.breakpoint.smAndUp}" v-if="section3">
        <a :href="section3.url" :target="section3.is_blank">
          <SectionsCardB :section_image="section3.image"/>
        </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SectionsCardB from './SectionsCardB';

export default {
  components: {
    SectionsCardB
  },
  methods: {
    ...mapActions("posts", ["fetchSectionPost"]),
    sectionToPost(slug) {
      this.$router.push({
        name: "post-show",
        params: { slug: slug }
      });
    },
    getSection(position) {
      return this.sections.filter ( section => section.position == position)[0];
    }
  },
  computed: {
    ...mapState("sections", ["sections"]),
    section1() {
      return this.getSection(1);
    },
    section2() {
      return this.getSection(2);
    },
    section3() {
      return this.getSection(3);
    }
  }
};
</script>

<style>
.decorated-destacados {
  overflow: hidden;
  text-align: center;
}
.decorated-destacados > span {
  position: relative;
  display: inline-block;
}
.decorated-destacados > span:before,
.decorated-destacados > span:after {
  content: "";
  position: absolute;
  top: 50%;
  border-bottom: 1px solid;
  width: 290%; /* half of limiter*/
  margin: 0 72px;
}
.decorated-destacados > span:before {
  right: 100%;
}
.decorated-destacados > span:after {
  left: 100%;
}
</style>